class inserInfoNoCtrl {
    constructor($scope, $uibModalInstance, items1, logger) {
        $scope.modaldata = items1
        $scope.modaldata.infoCodeNo = ''
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        function isInfoCode(v) {
            const _reg = /^\d{16}$/
            return _reg.test(parseFloat(v))
        }
        // 确定
        $scope.ok = function () {
            // 返回数据
            if (!isInfoCode($scope.modaldata.infoCodeNo)) {
                logger.logError('红字信息表编号为16位数字')
                return
            }
            $uibModalInstance.close($scope.modaldata)
        }
    }
}

inserInfoNoCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'logger']
export default inserInfoNoCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/inserInfoNoCtrl.js